// extracted by mini-css-extract-plugin
export default {"login":"Login_login__SzMdD","login__center":"Login_login__center__gX+Sw","title":"Login_title__ANnCk"};